import { Icon1, Icon2 } from "../../Common/Data/SvgIcons";
import IncomeCard from "./IncomeCard";
import IncomeChartClass from "./IncomechartCard";
import ProfileGreeting from "./ProfileGreetingCard";
import GrowthOverview from "./GrownCard";
import Login from "./creadential_keendroid";
import RecentToppers from "./Recent_toppers";
import UserCard from "./UserCard";
import TransactionCard from "./TransactionCard";
import { Container, Row, Col } from "reactstrap";
import image from "../../../assets/images/dummy_pic.jpeg";
import { HiOutlineUserCircle, HiOutlineUser } from "react-icons/hi";
import StudentAtt from "./StudentAtt";
import Progress from "./ProgressReport";
import { BaseURL, schoolyearID, uniqueToken } from "../../../api/DataApis";
import request from "../../../Apis/request";
// import {  } from "react-icons/fa";
import React from "react";
import { useEffect, useState } from "react";
// import { HiOutlineUserCircle } from 'react-icons/hi';
import { LuUsers2 } from "react-icons/lu";
import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import Loader from "../../../Modules/Chargers/Loader";
// import { faRupeeSign } from '@fortawesome/free-solid-svg-icons';

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [dashboardWidgetData, setDashboardWidgetData] = useState({});
  const [TotalAdmissions, setTotalAdmissions] = useState([]);
document.title = "Dashboard";
  const fetchData = async () => {
    setLoading(true);

    var url = `${BaseURL}/dashboard/getall`;

    let res = await request({
      url: url,
      method: "GET",
    
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);

    if (res && res.data) {
      setDashboardWidgetData(res?.data);
    }
    if (res && res?.data?.data) {
      setTotalAdmissions(res.dashboardWidget.newAdmissions);
    }

    setLoading(false); // Set loading to false after data is fetched
  };

  useEffect(() => {
    if (uniqueToken) {
      fetchData();
    }
  }, [uniqueToken]);

  const TotalAdmission = TotalAdmissions.new_admissions;

  console.log("dashboardData", dashboardWidgetData);
  console.log("TotalAdmissions", TotalAdmissions);
  console.log("TotalAdmission", TotalAdmission);
  return (
    <>
    { loading ? (
      <div className="loader-container">
        <Loader />
      </div>
    ) : (
    <Container fluid={true} className="dashboard-default-sec" style={{paddingLeft:"16px"}}>
     
      <Row>
        {/* <Col xl="5" className="box-col-12 des-xl-100"> */}
        <Row >
          <div className="col-md-3 mt-3 ">
            {/* <Image attrImage={{ className: 'img-fluid rounded-circle', src: image, alt: '', title: '' }} /> */}
            {/* <IncomeCard image  className="img-fluid rounder-circle" src= {image}  amount='8,50,49' title='Total Students'/> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' percent="95.54%" /> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' /> */}
            <IncomeCard
              iconClass={<HiOutlineUserCircle />}
              amount={dashboardWidgetData?.totalUserCount}
              title="Register Users"
              path="/usermanagement/users"
            />
          </div>
          <div className="col-md-3 mt-3 ">
            <IncomeCard
               iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount ={dashboardWidgetData?.totalUserWalletAmount ? dashboardWidgetData?.totalUserWalletAmount : Loader}
              percentage="98%"
              title="Total Users Wallet"
              path="/usermanagement/users"
            />
          </div>

          <div className="col-md-3 mt-3 ">
            <IncomeCard
              iconClass={<HiOutlineUserCircle />}
              amount ={dashboardWidgetData?.todayAddedUsers}
              percentage="98%"
              title="Today Added Users"
              path="/usermanagement/users"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayMoneyAddedWalletAmount}
              title="today's User Wallet Added"
              path="/statements/statementListing"
            />
          </div>

          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.totalVendorCount}
              title="Total Vendors"
              path="/usermanagement/vendors"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.totalVendorWalletAmount}
              title="Total Vendors Wallet"
              path="/usermanagement/vendors"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayAddedVendor}
              title="Today Added Vendors"
              path="/usermanagement/vendors"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<HiOutlineUserCircle/>} 
              amount={dashboardWidgetData?.todayVendorWalletAmount}
              title="Today Vendors Wallet Added"
              path="/usermanagement/vendors"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                  iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}></span>} 
              amount={dashboardWidgetData?.totalVendorUserCount}
              title="Total (Vendor+Users) Count"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                  iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.totalWalletAmount}
              title="Total Wallet Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                  iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}></span>} 
              amount={dashboardWidgetData?.todayAddedUserVendor}
              title="Today (Vendor+ Users) Count"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                  iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayVendorUserWalletAdded}
              title="Today Wallet Added"
              path="/statements/statementListing"
            />
          </div>

        
        </Row>

        <Row>
          <div className="col-md-3 mt-3 ">
            {/* <Image attrImage={{ className: 'img-fluid rounded-circle', src: image, alt: '', title: '' }} /> */}
            {/* <IncomeCard image  className="img-fluid rounder-circle" src= {image}  amount='8,50,49' title='Total Students'/> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' percent="95.54%" /> */}
            {/* <IncomeCard iconClass={<Icon1 />} amount='8,50,49' title='Total Students' /> */}
            <IncomeCard
              iconClass={<BsEvStation />}
              amount={dashboardWidgetData?.totalStationCount}
              title="Total Stations"
              path="/stations"
            />
          </div>

          <div className="col-md-3 mt-3">
            <IncomeCard
              iconClass={<BsEvStation/>}
              amount={dashboardWidgetData?.todayAddedStations}
              percentage="98%"
              title="Today Added Stations"
              path="/stations"
            />
          </div>

    <div className="col-md-3 mt-3">
            <IncomeCard
              iconClass={<FaChargingStation />}
              amount={dashboardWidgetData?.totalChargerCount}
              title="Total Chargers"
              path="/chargers"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
              iconClass={<FaChargingStation />}
              amount={dashboardWidgetData?.totalActiveCharger}
              title="Total Active Chargers"
              path="/chargers"
            />
          </div>

          <div className="col-md-3 mt-3">
            <IncomeCard
                 iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayRefundAmount}
              title="Today's Refund Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3 ">
            <IncomeCard
              iconClass={<HiOutlineUserCircle />}
              amount={dashboardWidgetData?.todayRefundCount}
              title="Today's Money Refunded Count"
              path=""
            />
          </div>
        
     
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayMoneyAddedDebitAmount}
              title="Today's Debited Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayMoneyAddedCreditAmount}
              title="Today's Credited Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
               iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.totalCollectionAmount}
              title="Today's Wallet"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayRequestAmount}
              title="Today's Paid Charging Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayChargingAmount}
              title="Today's Used Charging Amount"
              path="/statements/statementListing"
            />
          </div>
          <div className="col-md-3 mt-3">
            <IncomeCard
                iconClass={<span style={{ fontSize: "20px", fontWeight: "bold", color: "#28a745" }}>₹</span>} 
              amount={dashboardWidgetData?.todayVendorAmount}
              title="Today's Vendor  Collection"
              path="/statements/statementListing"
            />
          </div>
        
     
        </Row>
        {/* </Col> */}
        {/* <IncomeChartClass /> */}
        <Col xl="8" className="box-col-12 des-xl-100">
          <Row>
            <Col xl="6" className="col-50 box-col-6 des-xl-50">
              {/* <GrowthOverview /> */}
              {/* <StudentAtt /> */}
            </Col>
            <Col
              xl="6"
              className="col-50 box-col-6 des-xl-50"
             
            >
              {/* <Login /> */}
            </Col>
            {/* <Col xl="8" className="recent-order-sec"> */}
            {/* <RecentToppers /> */}
            {/* </Col> */}
          </Row>
        </Col>
        <Col xl="4" className="box-col-12 des-xl-100">
          <Row>
            <Col xl="12" className="box-col-6 des-xl-50">
              {/* <UserCard /> */}
            </Col>
            <Col xl="12" className="box-col-6 des-xl-50">
              {/* <Progress/> */}
            </Col>
          </Row>
        </Col>
      </Row> 
    </Container>)}
  
  </>
  )
};

export default Dashboard;
